import { Step } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	.MuiStepIcon-root,
	.MuiStepLabel-label {
		color: ${({ theme }) => theme.pantone2726C};

		.MuiStepIcon-text {
			display: none;
		}
	}
	.MuiStepLabel-label {
		font-size: 1rem;
	}

	.MuiStepConnector-lineVertical,
	.MuiStepConnector-vertical {
		display: none;
	}
`;
interface IContainerStep {
	lastStep: boolean;
}
export const ContainerStep = styled(Step)<IContainerStep>`
	&&& {
		.MuiStepContent-root {
			margin-top: 0px;
			border-color: ${({ theme }) => theme.pantone2726C} !important;
			border-left: ${(prop) => (prop.lastStep ? `1px solid ` : "unset")};
			margin-left: 10px;
			padding-left: 16px;
			padding-right: 0px;

			.MuiCollapse-root {
				padding-top: 5px;
				padding-bottom: 5px;
			}
		}
	}
`;

export const ContainerButton = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;

	button {
		padding: 5px 15px;
		min-width: unset;
		background: transparent;
	}
`;

export const BoxSeeShippingDetails = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	align-items: stretch;
	justify-content: center;
`;
